<template>
    <div :class="prefixCls" 
        :style="{ width: size }"
        @click="handleClick"
        @mouseenter="handleMouseEnter">
        <div :class="`${prefixCls}-info`">
            <span v-if="!isDisplayName && path" 
                :class="`${prefixCls}-content ${prefixCls}-content-path`">
                <img :src="path"
                    @error="handleOnError">
            </span>
            <span v-else 
                :style="{ backgroundColor: getColor() }"
                :class="`${prefixCls}-content ${prefixCls}-content-name`">
                <i :style="{ fontSize: fontSize }">
                    <slot name="icon">
                        {{formatName}}
                    </slot>
                </i>
            </span>
        </div>
    </div>
</template>
<script>
    import { getColor } from '../../../utils/utils'
    
    const prefixCls = 'yy-avatar'
    export default {
        name: 'YYAvatar',
        props: {
            size: {
                type: String,
                default: '64px'
            },
            fontSize: {
                type: String,
                default: '14px'
            },
            path: {
                type: String
            },
            name: {
                type: String,
                required: true
            }, 
            memberId: {
                type: [String, Number],
            },
            defaultPath: {
                type: String
            },
            displayIcon: { 
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                prefixCls: prefixCls,
                loadError: false
            }
        },
        computed: {
            isDisplayName() { // 当path中含有default字段的时候不使用默认图片
                let isDisplayName = false
                if(this.displayIcon || this.loadError 
                    || (this.path && this.path.indexOf('default_avatar') > 0) ) { 
                    isDisplayName = true
                }
                return isDisplayName
            },
            formatName: function() {
                return /[\u4e00-\u9fa5]/.test(this.name)
                    ? this.name.substr(-2)
                    : this.name.substr(0, 2);
            }
        },
        methods: {
            getColor() {
                return getColor(this.name)
            },
            handleOnError() {
                this.loadError = true
            }, 
            handleClick() {
                this.$emit('click', {
                    name: this.name,
                    memberId: this.memberId
                })
            },
            handleMouseEnter() {
                this.$emit('mouseenter', {
                    name: this.name,
                    memberId: this.memberId
                })
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/base/avatar/avatar.vue